import { AxiosError } from 'axios'
import { fromEntries } from 'effect/Record'
import { useTranslation } from 'next-i18next'
import { useEffect } from 'react'
import * as CookieConsent from 'vanilla-cookieconsent'
import { supportedLanguages } from 'domain/models/Translations/Translation'
import { apiClient } from 'services/api/client'
import {
  AD_PERSONALIZATION,
  AD_STORAGE,
  AD_USER_DATA,
  ANALYTICS_STORAGE,
  pluginConfig
} from './CookieConsentConfig'
import { cookieTranslation } from './CookieConsentTranslation'

import 'vanilla-cookieconsent/dist/cookieconsent.css'

const logConsent = () => {
  const cookie = CookieConsent.getCookie()
  const preferences = CookieConsent.getUserPreferences()
  apiClient
    .post('/cookie/save', {
      cookie,
      preferences
    })
    .catch((error: AxiosError) => {
      console.error('Error saving cookie consent:', error)
    })
}

const updateGtagConsent = () => {
  if (!window.gtag) {
    console.warn('gtag is not defined on the window object.')
    return
  }
  window.gtag('consent', 'update', {
    [AD_STORAGE]: CookieConsent.acceptedCategory(AD_STORAGE)
      ? 'granted'
      : 'denied',
    [AD_USER_DATA]: CookieConsent.acceptedCategory(AD_USER_DATA)
      ? 'granted'
      : 'denied',
    [AD_PERSONALIZATION]: CookieConsent.acceptedCategory(AD_PERSONALIZATION)
      ? 'granted'
      : 'denied',
    [ANALYTICS_STORAGE]: CookieConsent.acceptedCategory(ANALYTICS_STORAGE)
      ? 'granted'
      : 'denied'
  })
}
export const useCookieConsent = () => {
  const { t } = useTranslation('cookie')
  const cookieT = cookieTranslation(t)
  const translations = fromEntries(
    supportedLanguages.map((lang) => [lang, cookieT(lang)])
  )

  useEffect(() => {
    const cookieConsentTimeoutId = setTimeout(
      () =>
        CookieConsent.run(
          pluginConfig(translations, updateGtagConsent, logConsent)
        ),
      10000
    )
    return () => {
      clearTimeout(cookieConsentTimeoutId)
      CookieConsent.reset()
    }
  }, [t])
}
